import classNames from 'classnames';
import { PropsBlock } from './PropsBlock';

import styles from './Block.module.scss';

export const Block = ({ children, className, status, fullWidth, simple, dataTestId, ...props }: PropsBlock): JSX.Element => {
  return (
    <div
      {...props}
      className={classNames(styles.Block, className, fullWidth && styles.fullWidth, simple && styles.Simple, status && styles.Active)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
